/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseBroadcast } from '../models/api-response-broadcast';
import { createMediaVoucherBroadcast } from '../fn/voucher-api/create-media-voucher-broadcast';
import { CreateMediaVoucherBroadcast$Params } from '../fn/voucher-api/create-media-voucher-broadcast';
import { createVoucherBroadcast } from '../fn/voucher-api/create-voucher-broadcast';
import { CreateVoucherBroadcast$Params } from '../fn/voucher-api/create-voucher-broadcast';

@Injectable({ providedIn: 'root' })
export class VoucherApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createVoucherBroadcast()` */
  static readonly CreateVoucherBroadcastPath = '/v1/api/voucher';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createVoucherBroadcast()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createVoucherBroadcast$Response(params: CreateVoucherBroadcast$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseBroadcast>> {
    return createVoucherBroadcast(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createVoucherBroadcast$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createVoucherBroadcast(params: CreateVoucherBroadcast$Params, context?: HttpContext): Observable<ApiResponseBroadcast> {
    return this.createVoucherBroadcast$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseBroadcast>): ApiResponseBroadcast => r.body)
    );
  }

  /** Path part for operation `createMediaVoucherBroadcast()` */
  static readonly CreateMediaVoucherBroadcastPath = '/v1/api/voucher/media';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createMediaVoucherBroadcast()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createMediaVoucherBroadcast$Response(params: CreateMediaVoucherBroadcast$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseBroadcast>> {
    return createMediaVoucherBroadcast(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createMediaVoucherBroadcast$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createMediaVoucherBroadcast(params: CreateMediaVoucherBroadcast$Params, context?: HttpContext): Observable<ApiResponseBroadcast> {
    return this.createMediaVoucherBroadcast$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseBroadcast>): ApiResponseBroadcast => r.body)
    );
  }

}
